import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import type { TOrderFormParams } from '../types/order-form-params.type'
import { orderFormParamsService } from '../services/order-form-params.service'

type OrderFormParamsQueryProps = {
  companyId: number
  callback?: (data: TOrderFormParams) => void
}

export function useOrderFormParamsQuery({
  companyId,
  callback,
}: OrderFormParamsQueryProps) {
  const { data: orderFormParams, refetch: refetchOrderFormParams } =
    useQuery<TOrderFormParams>({
      queryKey: [QUERY_KEYS.ORDER_PARAMS, companyId],
      enabled: false,
      queryFn: async () => {
        const response = await orderFormParamsService({
          payload: {
            companyId,
          },
        })

        callback?.(JSON.parse(response.body))
        const data = JSON.parse(response.body)
        return data
      },
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    })
  return {
    orderFormParams,
    refetchOrderFormParams,
  }
}
